import { useBaseInsuranceService } from './baseInsuranceService';

/**
 * Service for handling home insurance policy operations
 * 
 * @returns {Object} Service methods for home insurance operations
 */
export function useHomeInsuranceService() {
  const { submitForm, fetchData, uploadFile } = useBaseInsuranceService();
  
  /**
   * Submit a home policy change request
   * 
   * @param {Object} formData - The policy change form data
   * @returns {Promise} Promise resolving to the API response
   */
  const submitPolicyChange = async (formData) => {
    const hasFile = formData.authorizationFile instanceof File;
    return submitForm('/policy-changes/home', formData, hasFile);
  };

  /**
   * Get available coverage options for home policies
   * 
   * @returns {Promise} Promise resolving to coverage options
   */
  const getCoverageOptions = async () => {
    return fetchData('/home-insurance/coverage-options');
  };

  /**
   * Validate policy number for a home insurance policy
   * 
   * @param {string} policyNumber - The policy number to validate
   * @returns {Promise} Promise resolving to validation result
   */
  const validatePolicy = async (policyNumber) => {
    return submitForm('/home-insurance/validate-policy', { policyNumber });
  };
  
  /**
   * Upload a document related to home insurance
   * 
   * @param {File} file - The file to upload
   * @param {Object} metadata - Metadata for the document
   * @returns {Promise} Promise resolving to the upload result
   */
  const uploadDocument = async (file, metadata) => {
    return uploadFile('/home-insurance/upload-document', file, metadata);
  };

  return {
    submitPolicyChange,
    getCoverageOptions,
    validatePolicy,
    uploadDocument
  };
} 